import { render, staticRenderFns } from "./NotasNivel2DadosListaDetalhado.vue?vue&type=template&id=5d4e4807"
import script from "./NotasNivel2DadosListaDetalhado.vue?vue&type=script&lang=js"
export * from "./NotasNivel2DadosListaDetalhado.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel2DadosListaDetalhado.vue?vue&type=style&index=0&id=5d4e4807&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports